import { Helmet } from "react-helmet-async";
import { SITE_URL, ORG_NAME, ORG_LEGAL_NAME, ORG_LOGO, ORG_SAMEAS } from "@/lib/seoConfig";

/**
 * Sitewide structured data. Mounted once at app root.
 * - Organization
 * - WebSite (with SearchAction)
 */
export default function SchemaOrg() {
  const org = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: ORG_NAME,
    legalName: ORG_LEGAL_NAME,
    url: SITE_URL,
    logo: ORG_LOGO,
    sameAs: ORG_SAMEAS,
    contactPoint: [{
      "@type": "ContactPoint",
      contactType: "customer support",
      email: "info@sparkread.net",
      availableLanguage: ["English"],
    }],
    description: "SparkRead is an adaptive AI literacy and reading comprehension platform for K-12, ELL, AP, SAT, and ACT learners.",
  };
  const site = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: ORG_NAME,
    url: SITE_URL,
    inLanguage: "en-US",
    potentialAction: {
      "@type": "SearchAction",
      target: `${SITE_URL}/practice?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(org)}</script>
      <script type="application/ld+json">{JSON.stringify(site)}</script>
    </Helmet>
  );
}
